import { reportPriceWithCurrency } from "../services/commerce/pricing";
import { AnalyticsConsentCard } from "../components/AnalyticsConsentCard";
import { PrivacyDisclosure } from "../components/PrivacyDisclosure";
import { StorageWarning } from "../components/StorageWarning";
import type { StorageHealth } from "../services/app/storage";
import { commerceEnabled } from "../services/commerce/config";
import { isMobileBuild } from "../services/platform/runtime";

interface StartRouteProps {
  hasDraft: boolean;
  storageHealth: StorageHealth | undefined;
  error?: string;
  onStart: () => void;
  onReports?: () => void;
}

export function StartRoute({ hasDraft, storageHealth, error, onStart, onReports }: StartRouteProps): JSX.Element {
  return (
    <section className="screen screen--center start-screen">
      <h1 className="start-title">MoveInReport</h1>
      <img
        className="start-art"
        src="/images/start-illustration.png"
        width="448"
        height="411"
        alt=""
        decoding="async"
        loading="eager"
      />
      <p className="start-headline">Protect your deposit before you unpack.</p>
      <p className="start-copy">Take photos, talk naturally, and export a clean evidence PDF.</p>
      {commerceEnabled && <p className="helper">{isMobileBuild() ? "A finished report requires a one-time purchase. Your store shows the price before you confirm." : `One finished report costs ${reportPriceWithCurrency}. No subscription.`}</p>}
      {error && <div className="notice notice--error">{error}</div>}
      <div className="button-row">
        <button className="button button--primary" type="button" onClick={onStart}>
          {hasDraft ? "Continue report" : "Start report"}
        </button>
      </div>
      {onReports && <button className="button button--secondary" type="button" onClick={onReports}>Your reports</button>}
      <p className="trust-line">Draft photos stay on this device. Optional PDF backup includes your photos and notes. Voice notes are sent for transcription with your consent.</p>
      <AnalyticsConsentCard />
      <StorageWarning health={storageHealth} />
      <PrivacyDisclosure />
      <nav className="button-row" aria-label="Information"><a href="/privacy">Privacy</a><a href="/terms">Terms</a><a href="/support">Support</a></nav>
    </section>
  );
}
